"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIdleSessionTimeout = setIdleSessionTimeout;
const lib_1 = require("../global/lib.js");
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
function setIdleSessionTimeout(context) {
    const sonarGlobalTimeout = new lib_1.SonarGlobalTimeout(sonar_ts_constants_1.APP_TIMEOUTS.IDLE, context);
    const events = [
        sonar_ts_constants_1.MOUSE_EVENTS.CLICK,
        sonar_ts_constants_1.MOUSE_EVENTS.KEYPRESS,
        sonar_ts_constants_1.MOUSE_EVENTS.MOUSEDOWN,
        sonar_ts_constants_1.MOUSE_EVENTS.MOUSEMOVE
    ];
    sonarGlobalTimeout.setTimeout();
    for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        document.addEventListener(event, () => {
            sonarGlobalTimeout.clearTimeout();
            sonarGlobalTimeout.setTimeout();
        });
    }
}
//# sourceMappingURL=lib.js.map